import {
  selectHexes,
  selectIsGameStarted,
  selectPhase
} from '../../redux/reducers/sharedStateReducer/selectors';
import {TERRAIN_TOKENS} from '../../constants/tokens';
import {PHASES} from '../../constants/phases';

/**
 * Можно ли нажать на ячейку поля. Море лишь помечает неигровую часть сетки и
 * не рисуется: в идущей партии нажатие на него — как мимо поля (ни инспекции
 * ячейки, ни игровых действий, ни курсора-руки). Пока поле редактируется (до
 * старта партии: фаза подготовки поля, редактор миссий) море — такая же
 * ячейка, как остальные: его ставят и стирают.
 */
export const checkIfHexClickable = (state, hexKey) => {
  if (selectHexes(state)?.[hexKey] !== TERRAIN_TOKENS.SEA) {
    return true;
  }
  return !selectIsGameStarted(state) || selectPhase(state) === PHASES.FIELD_PREPARATION;
};
